import React from "react";
import { DayPicker } from "react-day-picker";
import { format } from "date-fns";

export const InlineCalendar = ({ range, setRange, today, windowEnd, busyDates, nights, availLoading, availError }) => (
  <section className="mt-10 pt-8 border-t border-black/5 hidden lg:block" data-testid="inline-calendar">
    <div className="flex items-end justify-between gap-4">
      <div>
        <h2 className="font-heading font-bold text-xl text-ink">
          {nights > 0 ? `${nights} night${nights !== 1 ? "s" : ""} selected` : "Select check-in date"}
        </h2>
        <p className="text-sm text-ink-faint mt-1" data-testid="selected-dates">
          {range?.from && range?.to
            ? `${format(range.from, "dd MMM yyyy")} → ${format(range.to, "dd MMM yyyy")}`
            : "Add your travel dates for exact pricing"}
        </p>
      </div>
      {range?.from && (
        <button type="button" onClick={() => setRange(undefined)} className="text-sm font-semibold underline text-ink hover:text-brand shrink-0" data-testid="inline-clear-dates">
          Clear dates
        </button>
      )}
    </div>
    <div className="mt-4 rdp-wrap" style={{ "--rdp-cell-size": "44px" }}>
      <DayPicker
        mode="range" selected={range} onSelect={setRange}
        defaultMonth={range?.from || today} numberOfMonths={2}
        fromDate={today} toDate={windowEnd}
        disabled={[{ before: today }, ...busyDates]}
        data-testid="inline-date-picker"
      />
    </div>
    <p className="mt-2 text-xs text-ink-faint">
      {availLoading ? "Loading availability…" : availError ? "Couldn't load availability — all dates shown." : "Greyed-out dates are already booked."}
    </p>
  </section>
);

export default InlineCalendar;
